module.exports = __webpack_public_path__ + "img/attach.6c0aed73.svg";